import React from "react";

const NotFound = ({ message = "" }: { message: string }) => {
  return (
    <div className="errorWrapper">
      <div className="errorContainer">
        <div className="base-error-page default-error">
          <div className="error-logo"></div>
          <h1>We're sorry.</h1>
          <h4>{message}</h4>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
